import {
  registry,
  http
} from '@printos/agnostic-core';

import bootstrapServiceFactory from './bootstrap';
import appServiceFactory from './app';
import deviceServiceFactory from './device';
import iconServiceFactory from './icon';
import sessionServiceFactory from './session';
import helpersServiceFactory from './helpers';
import preferencesServiceFactory from './preferences';
import i18nServiceFactory from './i18n';
import helpServiceFactory from './help';
import notificationsServiceFactory from './notifications';
import goServiceFactory from './go';
import itemsServiceFactory from './items';
import mapServiceFactory from './map';
import marketServiceFactory from './market';
import dbServiceFactory from './db';
import uiServiceFactory from './ui';
import pusherServiceFactory from './pusher';
import googleAnalyticsFactory from './google-analytics';
import intercomFactory from './intercom';
import performanceFactory from './performance';
import ecommerceFactory from './ecommerce';
import consentFactory from './consent';
import optimizeFactory from './optimize';
import kzServiceFactory from './knowledge-zone';
import dateServiceFactory from './date';
import alertsServiceFactory from './alerts';

// This is a very simplistic service container.
// It's intended to store service instances so that
// configuration doesn't need to be plumbed to every instance
// and so instances can be reused, reducing garbage.
function createServices() {
  const services = {};

  // Create testable aliases for document and window globals
  services.document = document;
  services.window = window;

  services.registry = registry;
  services.http = http;
  services.bootstrap = bootstrapServiceFactory(services);
  services.icon = iconServiceFactory(services);
  services.session = sessionServiceFactory(services);
  services.helpers = helpersServiceFactory(services);
  services.preferences = preferencesServiceFactory(services);
  services.i18n = i18nServiceFactory(services);
  services.help = helpServiceFactory(services);
  services.pusher = pusherServiceFactory(services);
  services.notifications = notificationsServiceFactory(services);
  services.go = goServiceFactory(services);
  services.items = itemsServiceFactory(services);
  services.map = mapServiceFactory(services);
  services.market = marketServiceFactory(services);
  services.db = dbServiceFactory(services);
  services.ui = uiServiceFactory(services);
  services.app = appServiceFactory(services);
  services.device = deviceServiceFactory(services);
  services.ga = googleAnalyticsFactory(services);
  services.intercom = intercomFactory(services);
  services.performance = performanceFactory(services);
  services.ecommerce = ecommerceFactory(services);
  services.consent = consentFactory(services);
  services.optimize = optimizeFactory(services);
  services.knowledgeZone = kzServiceFactory(services);
  services.date = dateServiceFactory(services);
  services.alerts = alertsServiceFactory(services);

  return services;
}
export default createServices();
